export default __webpack_public_path__ + "static/media/3015.8fc67277.jpg";